import { MediumIcon } from '@factorialco/deprecated-design-system'

import { Pricing } from 'modules/upsell/lib/selfUpsell/calculator/Pricing'
import type Feature from 'modules/upsell/lib/selfUpsell/plans/Feature'
import { Plan } from 'modules/upsell/lib/selfUpsell/types'
import type { PlanTypeEnum, VariantsEnum } from 'modules/upsell/lib/selfUpsell/types'

export interface Discount {
  planToDiscount: PlanVariant
  value: number
}

export default class PlanVariant {
  public id: string // internalTitle
  public title: string
  public type: VariantsEnum
  public description: string
  public icon: MediumIcon
  public pricing: Pricing
  public isSelected: boolean
  public features: Feature[]
  public planType: PlanTypeEnum // only available in F25 plans
  public segmentationOption?: string
  public includedAddons?: Plan[]
  public includedExtraAddons?: Plan[]

  public constructor({
    id,
    title,
    type,
    description,
    segmentationOption,
    planType,
    icon,
    pricing,
    features,
    includedAddons,
    includedExtraAddons,
  }: {
    id: string
    title: string
    type: VariantsEnum
    description: string
    icon: MediumIcon
    pricing: Pricing
    features: Feature[]
    planType: PlanTypeEnum
    segmentationOption?: string
    includedAddons?: Plan[]
    includedExtraAddons?: Plan[]
  }) {
    this.id = id
    this.title = title
    this.type = type
    this.description = description
    this.segmentationOption = segmentationOption
    this.planType = planType
    this.icon = icon
    this.pricing = pricing
    this.isSelected = false
    this.features = features
    this.includedAddons = includedAddons
    this.includedExtraAddons = includedExtraAddons
  }

  // SELECT LOGIC
  public select() {
    this.isSelected = true
  }

  public unselect() {
    this.isSelected = false
  }
}
